import React, { useEffect, useState } from "react";
import { useGetAgronomyData, usePullAgronomyData } from "../../../api/agronomy";
import { Button, message, Table } from "antd";
import { render } from "@testing-library/react";
import { AntCloudOutlined } from "@ant-design/icons";

const columns = [
  {
    dataIndex: "landCode",
    title: "Land Code",
  },
  {
    title: "Forecast Date",
    render: (_: string, record: any) => {
      return (
        <div>{`${record.forecastStartDate} - ${record.forecastEndDate}`}</div>
      );
    },
  },
  {
    dataIndex: "forecastEn",
    title: "Forecast",
    render: (forecast: string, record: any) => {
      return (
        <div className="w-full" key={record.landCode}>
          {forecast.split(".").map((f: any) => {
            const [day, data] = f.split(":");
            return (
              <div
                key={Math.random()}
                className="flex justify-between w-full border-b-2 py-1"
              >
                <div className="text-green-400 text-md font-bold">{day}</div>
                <div>{data}</div>
              </div>
            );
          })}
        </div>
      );
    },
  },
];

function AgronomyTable() {
  const { data: forecast } = useGetAgronomyData();
  const {
    data: latestForecast,
    isLoading,
    refetch: featchLatestForecast,
    error,
  } = usePullAgronomyData();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (latestForecast && latestForecast.data && latestForecast.data.data) {
      setData(latestForecast.data.data);
    } else if (forecast && forecast.data && forecast.data.data) {
      setData(forecast.data.data);
    }
  }, [forecast, latestForecast]);

  useEffect(() => {
    if (error) {
      message.error(
        "Latest weather forecast not found. Check Sprout server is up."
      );
    }
  }, [error]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row justify-between bg-[#EEF3F8] px-8 py-4 rounded-[8.5px]">
        <div className="text-2xl font-semibold">Weather forecast</div>
        <Button
          loading={isLoading}
          icon={<AntCloudOutlined />}
          onClick={() => featchLatestForecast()}
        >
          Pull forecast
        </Button>
      </div>
      {/* <AgronomyTable /> */}
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        columns={columns}
        dataSource={forecast?.data?.data || []}
      />
    </div>
  );
}

export default AgronomyTable;
